/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@stoneage/XDL/Helpers";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            drawerTitle: css`
                background: transparent;
            `,
            drawerContainer: css`
                > div {
                    transition: 300ms ease-in-out;
                    background: ${getColor("common.white")};
                }
                #drawerTitle {
                }
            `,
            titleButton: css`
                padding: 0;
                box-shadow: none !important;
                border: 0 !important;
                background: transparent !important;
                span:nth-child(3) {
                    display: none;
                }
            `,
            headlineTypography: css`
                margin: 7px 0 10px 0;
            `,
        },
        closeButtonIconProps: {
            src: "IconCloseInactive",
            size: 24,
        },
        closeButtonProps: {
            shape: "pill",
            buttonType: "solid",
            size: 36,
            color: "common.background",
        },
    },
} as xBaseTheme["drawer"];
